// Status pill for every GroupedTrip state, used by both trips tables. The
// positive/"complete" pill uses the exact Figma colours (#00A440 on #F2FFF7
// with a #C2EED3 border); the other states keep semantic differentiation in the
// same pill shape. Colours are applied inline (Tailwind v1 has no `-50` shade).
export const STATUS_BADGE = {
  complete:        { label: "Complete",        bg: "#F2FFF7", text: "#00A440", border: "#C2EED3" },
  cancelled_late:  { label: "Late",            bg: "#EEEDF0", text: "#807E83", border: "#D1CFD4" },
  cancelled_early: { label: "Cancelled Early", bg: "#FDECEC", text: "#C81E1E", border: "#F3C2C2" },
  on_route:        { label: "On Route",        bg: "#E8F0FE", text: "#1E56C8", border: "#C2D4F5" },
  accepted:        { label: "Accepted",        bg: "#EEECF0", text: "#745D96", border: "#C2B8CE" },
  scheduled:       { label: "Scheduled",       bg: "#EEECF0", text: "#745D96", border: "#C2B8CE" },
  pending:         { label: "Pending",         bg: "#FFF7E6", text: "#B7791F", border: "#F3E1B8" },
};

// Eta-Purple brand token. Not in the Tailwind theme (purple-500 is a different
// #776591), so it lives here as the single source of truth for the driver page.
export const ETA_PURPLE = "#745D96";

// Shared white-card surface (radius + shadow) from the Figma design. Cards add
// their own padding on top and size to their content.
export const CARD_SURFACE = { borderRadius: 16, boxShadow: "0 0 4px rgba(0,0,0,0.15)" };

export const PAGE_SIZE = 10;

export const CURRENCY_FORMATTER = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
